import type { UpgradeChargeStatus } from '@/shared/api';
import type { PillProps } from '@/shared/components';

interface Presentation {
  label: string;
  detail: string;
  variant: NonNullable<PillProps['variant']>;
}

export const upgradeChargePresentation: Record<UpgradeChargeStatus, Presentation> = {
  Draft: {
    label: 'Entwurf',
    detail: 'Der Zahlungslink wurde noch nicht gesendet.',
    variant: 'default',
  },
  Open: {
    label: 'Offen',
    detail: 'Der Gast kann den Aufpreis jetzt bezahlen.',
    variant: 'warning',
  },
  PaymentStarted: {
    label: 'Zahlung läuft',
    detail: 'Stripe verarbeitet diesen Vorgang.',
    variant: 'warning',
  },
  CancellationPending: {
    label: 'Wird aufgehoben',
    detail: 'Stornierung oder Vollerstattung läuft.',
    variant: 'warning',
  },
  Cancelled: {
    label: 'Aufgehoben',
    detail: 'Der Vorgang ist ohne Belastung beendet.',
    variant: 'stop',
  },
  Paid: {
    label: 'Bezahlt',
    detail: 'Zahlung bestätigt; der Beleg wird bereitgestellt.',
    variant: 'live',
  },
  Refunded: {
    label: 'Erstattet',
    detail: 'Die technische Vollerstattung ist abgeschlossen.',
    variant: 'default',
  },
  Expired: { label: 'Abgelaufen', detail: 'Ein neuer Link kann gesendet werden.', variant: 'stop' },
  ReviewRequired: {
    label: 'Klärung nötig',
    detail: 'Bitte den Vorgang in Finance prüfen.',
    variant: 'stop',
  },
};

export function canSendUpgradeCharge(status: UpgradeChargeStatus) {
  return ['Draft', 'Open', 'PaymentStarted', 'Expired'].includes(status);
}

export function canCancelUpgradeCharge(status: UpgradeChargeStatus) {
  return ['Draft', 'Open', 'PaymentStarted'].includes(status);
}
